module.exports = __webpack_public_path__ + "img/rubrica.b4509db3.png";